import { AfterViewInit, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import moment from 'moment';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { DeleteStatus, GuestType, MasterDataStatus, OperationType, SharedService } from '../../shared/shared.service';
import { ProxyDynamicService } from '../../shared/service/proxy-dynamic.service';
import { EMPTY, forkJoin, map, switchMap } from 'rxjs';
import { NzNotificationService } from "ng-zorro-antd/notification";
import { TranslateService } from "@ngx-translate/core";


@Component({
  selector: 'app-exchange-item',
  templateUrl: './exchange.component.html',
  styleUrl: './exchange.component.scss'
})
export class ExchangeItemComponent implements OnInit, AfterViewInit {
  readonly nzModalData = inject(NZ_MODAL_DATA);
  formGroup!: FormGroup;
  expand: boolean = true;
  expandService: boolean = true;
  expandExchange: boolean = true;
  currentDate = moment().endOf('day').toDate();

  listDetailService: any[] = [];
  listDetailCash: any[] = [];
  listApartmentType: any[] = [];
  listApartmentTypeCache: any[] = [];
  listPackageCache: any[] = [];
  listPackage: any[] = [];
  listApartmentByCard: any[] = [];
  ownerId: string = '';
  total_exchange: number = 0;
  remaining_stock: number = 0;
  total_service: number = 0;
  total_amount: number = 0;
  total_amount_remaining: number = 0;
  total_cash: number = 0;
  get f() {
    return this.formGroup.controls;
  }
  listGuestType = [
    { text: 'owner.label', value: GuestType.Owner },
    { text: 'guest', value: GuestType.Guest },
  ]
  apartment: any;
  constructor(
    private fb: FormBuilder,
    private modalRef: NzModalRef,
    private service: ProxyDynamicService,
    private sharedService: SharedService,
    private noti: NzNotificationService,
    private translate: TranslateService
  ) {
    this.listDetailCash = (this.nzModalData.listDetailCash || []).map((item: any) => {
      return {
        ...item,
        exchange_expired_date: null
      }
    })

    this.listDetailService = (this.nzModalData.listDetailService || []).map((item: any) => {
      return {
        ...item,
        isNewRow: false,
        exchange_expired_date: null,
        exchange_amount: null
      }
    });
    if (this.nzModalData.apartment) {
      this.apartment = this.nzModalData.apartment;
    }
  }

  ngOnInit(): void {
    this.formGroup = this.fb.group({
      id: [undefined],
      card_no: [null],
      owner: [null],
      apartment_ids: [null],
      reason: [null],
      note: [null],
    })
    this.getMasterData();
  }

  ngAfterViewInit(): void {
    this.f['card_no'].disable()
    this.f['owner'].disable()
    this.f['id'].setValue(this.nzModalData.id)
    this.total_exchange = this.listDetailService.reduce((sum, item) => sum + (item.total_amount || 0), 0);
    this.remaining_stock = this.listDetailService.reduce((sum, item) => sum + (item.remaining_stock || 0), 0);
    this.total_amount = this.listDetailCash.reduce((sum, item) => sum + (item.total_amount || 0), 0);
    this.total_amount_remaining = this.listDetailCash.reduce((sum, item) => sum + (item.total_amount_remaining || 0), 0);
  }

  getMasterData() {
    let listPackageMasterData: any[] = [];
    const listAPI = [
      this.service.search('apartment_type', { filter: { deleted: { '_eq': DeleteStatus.NO } } }),
      this.service.search('package', { fields: ['*.*'], filter: { deleted: { '_eq': DeleteStatus.NO }, status: { '_eq': MasterDataStatus.Active } }, sort: '-code' }),
    ]
    forkJoin(listAPI).pipe(map(([listApartmentType, listPackage]) => ({
      listApartmentType: listApartmentType.map((item: any) => {
        item['text'] = item.name;
        item['value'] = item.id;
        return item;
      }),
      listPackage: listPackage.map((item: any) => {
        item['text'] = item.code + ' - ' + item.name;
        item['value'] = item.id;
        return item;
      }),
    })), switchMap((e: any) => {
      listPackageMasterData = e.listPackage;
      this.listApartmentTypeCache = e.listApartmentType;
      return this.service.search('promotion_setting', {
        field: ['package_id', 'fund_value'],
        filter: { fund_value: { '_gt': 0 }, package_id: { '_in': listPackageMasterData.map((r: any) => r.value) } }
      })
    }))
      .subscribe(e => {
        this.listPackageCache = listPackageMasterData.filter((r: any) => e.findIndex((i: any) => i.package_id === r.value) === -1);
        this.listPackage = this.listPackageCache
        this.getCardInfo(this.nzModalData.id)
      })
  }

  getCardInfo(id: string) {
    this.service.findById('service_card', id, {
      fields: ['*', 'owner_id.code', 'owner_id.name', 'butler_id.code', 'butler_id.name',
        'apartment_ids.apartment_id.*', 'apartment_ids.deleted']
    }).then(res => {
      if (res) {
        this.f['card_no'].setValue(res['card_no'], { emitEvent: false });
        this.ownerId = res['owner_id']?.id || res['butler_id']?.id;
        if (res['owner_id']) {
          this.f['owner'].setValue([res['owner_id']?.code, res['owner_id']?.name].join(' - '), { emitEvent: false });
        } else {
          this.f['owner'].setValue([res['butler_id']?.code, res['butler_id']?.name].join(' - '), { emitEvent: false });
        }

        if (res['apartment_ids']) {
          this.listApartmentByCard = res['apartment_ids'].filter((item: any) => item.deleted === DeleteStatus.NO && 
          item.apartment_id.deleted === DeleteStatus.NO).map((item: any) => ({
            ...item.apartment_id,
            value: item.apartment_id.id,
            text: item.apartment_id.code,
          }));
          this.f['apartment_ids'].setValue(this.listApartmentByCard.map((item: any) => item.id), { emitEvent: false });
          const operationTypes = new Set(this.listApartmentByCard.map((item: any) => item.operation_type));
          this.listPackage = this.listPackageCache.filter((item: any) => operationTypes.has(item.operation_type))
          const apartmentTypeIds = new Set(this.listApartmentByCard.map((item: any) => item.apartment_type));
          this.listApartmentType = this.listApartmentTypeCache.filter((a: any) => apartmentTypeIds.has(a.id));
        }
      }
    }, (error) => {
      this.service.handleError(error)
    })
  }

  onChangeService(item: any, event: any) {
    item.package_id = event;
  }

  onChangeApartmentType(item: any, event: any) {
    item.apartment_type_id = event;
  }

  onChangeGuestType(item: any, event: any) {
    item.guest_type = event;
  }

  onChangeQuantity(item: any, event: any) {
    if(event !== '' && event !== null){
      if (item.isNewRow) {
        item.difference = event;
      } else {
        item.difference = event - item.remaining_stock;
      }
      item.exchange_amount = event;
    } else {
      item.difference = null;
      item.exchange_amount = null;
    }
    this.total_service = this.listDetailService.reduce((total: any, item: any) => total + (item.exchange_amount ?? 0), 0);
  }

  onChangeDateCash(item: any, event: any) {
    item.exchange_expired_date = event;
  }

  onChangeAmount(item: any, event: any) {
    if(event !== '' && event !== null){
      item.exchange_amount = event;
      item.difference = event - item.total_amount_remaining;
    } else {
      item.exchange_amount = null;
      item.difference = null;
    }
    const total = this.listDetailCash.reduce((total: any, item: any) => total + (item.exchange_amount ?? 0), 0)
    this.total_cash = isNaN(total) ? 0 : total;
  }

  onChangeDateService(item: any, event: any) {
    item.exchange_expired_date = event;
  }

  onSave() {
    if (this.formGroup.valid && !this.validateNewService()) {
      const dataExchangeCard = this.formGroup.getRawValue();
      const toExchangeItem = (item: any) => ({
        ...item,
        exchange_expired_date: item.exchange_expired_date ? moment(item.exchange_expired_date).utc(true).toDate() : undefined,
        operation_type: this.listPackageCache.find((p: any) => p.id === item.package_id)?.operation_type,
      });
      dataExchangeCard.exchange_services = this.listDetailService.map(toExchangeItem);
      dataExchangeCard.exchange_cashs = this.listDetailCash.map(toExchangeItem);
      dataExchangeCard.service_card_id = this.f['id'].value;
      this.service.postCardVoucherFund(dataExchangeCard).pipe(
        switchMap(res => {
          if (!res) {
            return EMPTY;
          }

          const idSet = new Set(this.f['apartment_ids'].value);
          const isSame = this.listApartmentByCard.length === this.f['apartment_ids'].value.length && this.listApartmentByCard.every(apt => idSet.has(apt.id));
          const apartmentUpdates$ = this.f['apartment_ids'].value.map((id: any) => {
            const apartment = this.listApartmentByCard.find((item: any) => item.id === id);
            apartment.operation_type = apartment.operation_type === OperationType.SelfManaged ? OperationType.OwnerManaged : OperationType.SelfManaged;
            apartment.topup_transaction = undefined;
            apartment.text = undefined;
            apartment.value = undefined;
            return this.service.updateItemApartment(apartment);
          });

          if (!isSame) {
            const body = {
              apartment_ids: this.f['apartment_ids'].value,
              note: this.f['note'].value,
            };
            const changeApartment$ = this.service.changeApartment(this.nzModalData.id, body);
            return forkJoin([changeApartment$, ...apartmentUpdates$]);
          } else {
            return forkJoin(apartmentUpdates$);
          }
        })
      ).subscribe({
        next: () => {
          this.sharedService.showLoading(false);
          this.noti.create('success', '', this.translate.instant('service-card.exchange-success', { name: dataExchangeCard.card_no }));
          this.modalRef.destroy(true);
        },
        error: error => {
          this.sharedService.showLoading(false);
          this.service.handleError(error);
        }
      });
    } else {
      this.sharedService.showLoading(false);
      Object.values(this.formGroup.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  deleteService(index: number) {
    this.listDetailService.splice(index, 1)
    const total = this.listDetailService.reduce((total: any, item: any) => total + item.difference, 0)
    this.total_service = isNaN(total) ? 0 : total;
  }

  addService() {
    const newRow = {
      package_id: null,
      apartment_type_id: null,
      guest_type: null,
      used_amount: null,
      remaining_stock: null,
      expired_date: null,
      exchange_amount: null,
      exchange_expired_date: null,
      difference: null,
      isNewRow: true
    };
    this.listDetailService.push(newRow);
  }

  destroyModal() {
    this.modalRef.destroy()
  }

  validateNewService(): boolean {
    const newServices = this.listDetailService.filter(r => r.isNewRow);
    const oldServices = this.listDetailService.filter(r => !r.isNewRow);
    const hasEmptyFields = this.validateEmptyFields(newServices);
    if (hasEmptyFields) {
      this.noti.error('', this.translate.instant('service-card.error-field-empty'));
      return true;
    }
    const duplicateService = this.findDuplicateService(newServices, oldServices);
    if (duplicateService) {
      this.showDuplicateError(duplicateService);
      return true;
    }
    return false;
  }

  private validateEmptyFields(services: any[]): boolean {
    return services.some(service =>
      !service.package_id ||
      !service.apartment_type_id ||
      !service.exchange_amount ||
      !service.exchange_expired_date
    );
  }

  private findDuplicateService(newServices: any[], oldServices: any[]): any | null {
    for (const newService of newServices) {
      const isDuplicate = oldServices.some(oldService =>
        this.isSameService(oldService, newService)
      );
      if (isDuplicate) return newService;
    }
    const serviceKeys = new Set<string>();
    for (const newService of newServices) {
      const key = this.getServiceKey(newService);
      if (serviceKeys.has(key)) {
        return newService;
      }
      serviceKeys.add(key);
    }
    return null;
  }

  private isSameService(service1: any, service2: any): boolean {
    return service1.package_id === service2.package_id &&
      service1.apartment_type_id === service2.apartment_type_id &&
      service1.guest_type === service2.guest_type;
  }

  private getServiceKey(service: any): string {
    return `${service.package_id}_${service.apartment_type_id}_${service.guest_type}`;
  }

  private showDuplicateError(service: any): void {
    const packageItem = this.listPackage.find(i => i.value === service.package_id);
    const apartmentTypeItem = this.listApartmentType.find(i => i.value === service.apartment_type_id);
    this.noti.error('', this.translate.instant('service-card.error-duplicate-service', {
      package: packageItem?.text,
      type: apartmentTypeItem?.text
    }));
  }
}
